import { Injectable } from '@angular/core';
import { AppService } from '@shared/services/core/app.service';
import { HttpClient } from '@angular/common/http';
import { APIResponse, MFAPreferMasterPayload, MFAQRCodePayload } from '@shared/models/auth.interface';
import { SessionService } from './session.service';
import { AppMFAPayload, retrySendCodepayload, SavePreferencesPayload, UserSpecificMFA, verifyOTPPayload } from '@shared/models/mfa-prefrences.interface';
import { map } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UserprofileMfaService {
    private _clientPortalAPIDomain!: string;

  constructor(  private _appService: AppService,private http: HttpClient,private sessionService: SessionService) {
    this._clientPortalAPIDomain = this._appService.getAppConfigs()["CLIENTPORTAL"].BaseUrl;
  }


//   getMfaQrCode(payload: MFAQRCodePayload){
//     const getMFAQR = this._appService.getAppConfigs()["CLIENTPORTAL"].Versions.V1["MFAQRCode"]["GetMFAQRCode"].PATH;
//     const url = this._clientPortalAPIDomain + getMFAQR + '?' + this.prepareQueryParameters(payload);
//    return this.http.get<APIResponse<any>>(url).pipe(map((response: { Data: any; }) => response.Data));

// }

getMFAPreferences(payload: MFAPreferMasterPayload){
  const getMFApref = this._appService.getAppConfigs()["CLIENTPORTAL"].Versions.V1["MFAPreferences"]["GetMFAPref"].PATH;
  const url = this._clientPortalAPIDomain + getMFApref + '?' + this.prepareQueryParameters(payload);
  return this.http.get<APIResponse<any>>(url);

}


SaveMFAPrefrences(requestBody: SavePreferencesPayload) {
    const savePref = this._appService.getAppConfigs()["CLIENTPORTAL"].Versions.V1["SaveUserMFAPrefrences"]["MFASave"].PATH;
    const url = this._clientPortalAPIDomain + savePref;
    return this.http.post<APIResponse<boolean>>(url, requestBody);
  }

 VerifyOTP(requestBody: verifyOTPPayload) {
    const savePref = this._appService.getAppConfigs()["CLIENTPORTAL"].Versions.V1["MFAverifyOTP"]["verifyOtp"].PATH;
    const url = this._clientPortalAPIDomain + savePref;
    return this.http.post<APIResponse<boolean>>(url, requestBody);
  }

  retryAuthMFAPostLogin(requestBody: retrySendCodepayload) {
  const retryAuth = this._appService.getAppConfigs()["CLIENTPORTAL"].Versions.V1["RetryOTPPostLogin"]["RetryOTP"].PATH;
  const url = this._clientPortalAPIDomain + retryAuth;
  return this.http.post<APIResponse<any>>(url, requestBody);
}


getMfaQRPostLogIn(payload: MFAQRCodePayload){
  const getMFAQR = this._appService.getAppConfigs()["CLIENTPORTAL"].Versions.V1["MFAQRCodePostLogin"]["RestMFAQRCode"].PATH;
  const url = this._clientPortalAPIDomain + getMFAQR + '?' + this.prepareQueryParameters(payload);
  return this.http.get<APIResponse<any>>(url).pipe(map((response: { Data: any; }) => response.Data));

}

setUserMFA(requestBody: UserSpecificMFA) {
  const userMFA = this._appService.getAppConfigs()["CLIENTPORTAL"].Versions.V1["UserSpecifiedMFA"]["SetUserMFA"].PATH;
  const url = this._clientPortalAPIDomain + userMFA;
  return this.http.post<APIResponse<any>>(url, requestBody);
}



  private prepareQueryParameters(payload: Object): string {
    let queryParameters = [];
    for (const keyValue of Object.entries(payload)) {
      const parameter = keyValue[0];
      const value = keyValue[1];
      queryParameters.push(`${parameter}=${value}`);
    };
    return queryParameters.join('&');
  }

  updateMobileAuthMFA(requestBody: AppMFAPayload) {
    const userMFA = this._appService.getAppConfigs()["CLIENTPORTAL"].Versions.V1["MFAUpdateMobileAuth"]["updateMobileAuth"].PATH;
    const url = this._clientPortalAPIDomain + userMFA;
    return this.http.post<APIResponse<any>>(url, requestBody);
  }
  
}
